import React from "react"
import {sortBy} from 'lodash'
import { Form, Modal, Button, FormGroup, ControlLabel, FormControl } from "react-bootstrap"

import Dropdown from '../../../components/Dropdown'
import { handleKeyPress } from '../../../utils'

import * as unitService from "../../../services/organizational-units-service"
import * as locationService from "../../../services/location-service"

export default class OrganizationalUnitModal extends React.Component {
  constructor(props, context) {
    super(props, context)

    this.handleShow = this.handleShow.bind(this)
    this.handleHide = this.handleHide.bind(this)
    this.handlePost = this.handlePost.bind(this)
    this.handleNameChange = this.handleNameChange.bind(this)
    this.handleLocationChange = this.handleLocationChange.bind(this)

    this.state = {
      unit: {},
      location: undefined,
      locations: [],
      message: ''
    }
  }

  handleShow() {
    locationService.getLocations().then(locations => this.setState({ locations: locations, show: true }))

    if (this.props.id) {
      unitService.getUnitById(this.props.id).then(unit => {
        this.setState({
          unit: unit
        })
        locationService.getLocationById(unit.locationId).then(location => this.setState({ location }))
      })
    }
  }

  handleHide() {
    this.setState({ show: false, unit: {}, location: undefined })
  }

  handlePost() {
    if (this.validate()) {
      const unit = this.state.unit
      unitService
        .upsertUnit(unit).then(() => {
          this.handleHide()
          this.props.reload()
          this.setState({message: ''})
      }).catch(error => {this.setState({message: 'Opslaan mislukt. Mogelijk bestaat deze eenheid al.'})})
    }
  }

  handleLocationChange(location) {
    let unit = this.state.unit
    unit.locationId = location.id
    unit.locationName = location.name
    this.setState({ unit: unit, location: location })
  }

  handleNameChange(e) {
    let unit = this.state.unit
    unit.name = e.target.value
    this.setState({ unit: unit })
  }

  validate() {
    const { unit } = this.state
    return unit.name && unit.name.length > 0 && unit.locationId
  }

  render() {
    const { locations, location, unit, message } = this.state
    const { title, textbt, modalbttext } = this.props

    return (
      <div>
        <Button
          bsStyle="primary"
          className="edit-entry action-btn"
          onClick={this.handleShow}
        >
          {textbt}
        </Button>

        <Modal
          {...this.props}
          show={this.state.show}
          onHide={this.handleHide}
          onKeyPress={(e) => handleKeyPress(e, this.handlePost)}
          dialogClassName="custom-modal modal-new-unit"
          backdrop={false}>

          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-lg">
              {title}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {message && <div className='error'>{message}</div>}
            <p>{this.props.text}</p>

            <Form>
              <FormGroup controlId="unit">
                <ControlLabel>Naam organisatorische eenheid *</ControlLabel>{' '}
                <FormControl onChange={this.handleNameChange} type="text" value={unit && unit.name} />
              </FormGroup>

              <FormGroup className="has-dropdown">
                <ControlLabel>Hoort bij locatie *</ControlLabel>{' '}
                <Dropdown
                  dlClassNames='form-control'
                  controlWidth={2}
                  value={location}
                  data={sortBy(locations, "name")}
                  id='location_selector'
                  textField='name'
                  onChange={(e) => this.handleLocationChange(e)} />
              </FormGroup>
            </Form>
          </Modal.Body>

          <Modal.Footer>
            <Button bsStyle="primary" onClick={this.handlePost} disabled={!this.validate()}>
              {modalbttext}
            </Button>
            <Button onClick={this.handleHide}>Annuleren</Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Organizationalunits/modal/OrganizationalUnitModal.js